<template>
    <MultiSelect
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="personOptions"
        optionLabel="label"
        :optionValue="optionValue"
        filter
        v-bind="$attrs"
    >
        <template #option="slotProps">
            <PersonSelectOption :label="slotProps.option.label" :nif="slotProps.option.nif" />
        </template>
    </MultiSelect>
</template>

<script setup lang="ts">
import PersonSelectOption from '@/components/common/person/PersonSelectOption.vue'
import type Driver from '@/model/Driver'
import type Employee from '@/model/Employee'
import { formatPersonLabel } from '@/utils/selectDisplayUtils'
import { computed } from 'vue'

const props = defineProps<{
    people: Employee[] | Driver[]
    modelValue?: Employee[] | Driver[] | string[] | null
    optionValue?: string
}>()

defineEmits<{
    'update:modelValue': [value: Employee[] | Driver[] | string[] | null | undefined]
}>()

const personOptions = computed(() =>
    props.people.map((person) => ({
        ...person,
        label: formatPersonLabel(person.name, person.surname)
    }))
)
</script>
